
export { a11yPlugin } from './src/index';
